import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"color":"#000"} }
const _hoisted_2 = { "element-loading-text": "正在保存数据，请稍后" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("货币信息")
const _hoisted_4 = { class: "dialog-footer" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("保 存")

import { reactive, ref, unref } from 'vue';
import { GetNationInfoApi, NationCreateApi, NationEditApi } from '../../../../apis/basics/nation.api';
import { ElMessage, FormRules, ElForm } from 'element-plus';


export default /*#__PURE__*/_defineComponent({
  emits: ['onSaveSuccess'],
  setup(__props, { expose, emit: $emits }) {


const elFormRef = ref<InstanceType<typeof ElForm>>()

const state = reactive({
    loading: false,
    title: '国家数据编辑器',
    showDialog: false,
    rules: {
        nation_code: [{ required: true, message: '', trigger: 'blur' }],
        nation_name_cn: [{ required: true, message: '', trigger: 'blur' }],
        nation_name_en: [{ required: true, message: '', trigger: 'blur' }],
        nation_full_name: [{ required: true, message: '', trigger: 'blur' }],
        nation_iso_code: [{ required: true, message: '', trigger: 'blur' }],
        continent: [{ required: true, message: '', trigger: 'blur' }],
        is_enabled: [{ required: true, message: '', trigger: 'blur' }],
        currency_name_cn: [{ required: true, message: '', trigger: 'blur' }],
        currency_name_en: [{ required: true, message: '', trigger: 'blur' }],
        symbol_tandard: [{ required: true, message: '', trigger: 'blur' }],
    } as FormRules
})

const formSchema = ref<any>({})

const load = {
    getNationDetail: async (nationId: string) => {
        state.loading = true;
        const { succeeded, data, errors } = await GetNationInfoApi(nationId)
        if (!succeeded) {
            ElMessage.error(errors)
        } else {
            data.continent = `${data.continent}`
            formSchema.value = data ?? {};
        }
        state.loading = false;
    }
}

const actions = {
    save: () => {
        unref(elFormRef)?.validate(async (isvalid: boolean) => {
            if (!isvalid) return;

            const schema = unref(formSchema)
            const api = !schema.id ? NationCreateApi : NationEditApi;

            const onSuccess = (res: any) => {
                const { succeeded, errors } = res
                if (!succeeded) {
                    ElMessage.error(errors)
                } else {
                    ElMessage.success('保存成功')
                    state.showDialog = false;
                }
            }

            const onError = (err: any) => {
                ElMessage.error(err.message);
            }

            const onFinally = () => {
                state.loading = false;
                $emits('onSaveSuccess')
            }

            await api(schema).then(onSuccess).catch(onError).finally(onFinally);
        })
    }
}

const expFuncs = {
    showDialog: (nationRow: any) => {
        if (!nationRow.id) {
            state.title = '添加“国家/地区”数据'
            formSchema.value = { sort: 100, is_enabled: 'Y' }
        } else {
            state.title = '修改“国家/地区”数据'
            load.getNationDetail(nationRow.id);
        }
        state.showDialog = true;
    }
}

expose({ ...expFuncs })

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _unref(state).showDialog,
    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(state).showDialog) = $event)),
    size: "small",
    width: 600
  }, {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", null, _toDisplayString(_unref(state).title), 1)
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_4, [
        _createVNode(_component_el_button, {
          disabled: _unref(state).loading,
          size: "small",
          onClick: _cache[13] || (_cache[13] = ($event: any) => (_unref(state).showDialog = false))
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          disabled: _unref(state).loading,
          size: "small",
          type: "primary",
          onClick: actions.save
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createVNode(_unref(ElForm), {
          ref_key: "elFormRef",
          ref: elFormRef,
          "label-width": "100px",
          size: "small",
          model: formSchema.value,
          "label-position": 'right',
          rules: _unref(state).rules
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, { gutter: 10 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "国家/地区编号",
                      prop: "nation_code"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: formSchema.value.nation_code,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formSchema.value.nation_code) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "ISO编号",
                      prop: "nation_iso_code"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: formSchema.value.nation_iso_code,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formSchema.value.nation_iso_code) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "名称(中文)",
                      prop: "nation_name_cn"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: formSchema.value.nation_name_cn,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formSchema.value.nation_name_cn) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "名称(英文)",
                      prop: "nation_name_en"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: formSchema.value.nation_name_en,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formSchema.value.nation_name_en) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "名称(全称)",
                      prop: "nation_full_name"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: formSchema.value.nation_full_name,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formSchema.value.nation_full_name) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "所在大陆",
                      prop: "continent"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          style: {"width":"100%"},
                          modelValue: formSchema.value.continent,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formSchema.value.continent) = $event)),
                          placeholder: "国家所属大洲"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              label: "亚洲",
                              value: "1"
                            }),
                            _createVNode(_component_el_option, {
                              label: "欧洲",
                              value: "2"
                            }),
                            _createVNode(_component_el_option, {
                              label: "北美洲",
                              value: "3"
                            }),
                            _createVNode(_component_el_option, {
                              label: "南美洲",
                              value: "4"
                            }),
                            _createVNode(_component_el_option, {
                              label: "非洲",
                              value: "5"
                            }),
                            _createVNode(_component_el_option, {
                              label: "大洋洲",
                              value: "6"
                            }),
                            _createVNode(_component_el_option, {
                              label: "南极洲",
                              value: "7"
                            }),
                            _createVNode(_component_el_option, {
                              label: "其他",
                              value: "9"
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "状态",
                      prop: "is_enabled"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          style: {"width":"100%"},
                          modelValue: formSchema.value.is_enabled,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formSchema.value.is_enabled) = $event)),
                          placeholder: "启用状态"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              label: "启用",
                              value: "Y"
                            }),
                            _createVNode(_component_el_option, {
                              label: "停用",
                              value: "N"
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "排序" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input_number, {
                          modelValue: formSchema.value.sort,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formSchema.value.sort) = $event)),
                          min: 1,
                          style: {"width":"100%"}
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "备注",
                      prop: "remark"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: formSchema.value.remark,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formSchema.value.remark) = $event)),
                          type: "textarea",
                          "show-word-limit": "",
                          maxlength: "200",
                          rows: "5",
                          placeholder: "备注信息"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_divider, { "content-position": "center" }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "货币(中文)",
                      prop: "currency_name_cn"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: formSchema.value.currency_name_cn,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formSchema.value.currency_name_cn) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "货币(英文)",
                      prop: "currency_name_en"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: formSchema.value.currency_name_en,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formSchema.value.currency_name_en) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "标准符号",
                      prop: "symbol_tandard"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: formSchema.value.symbol_tandard,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formSchema.value.symbol_tandard) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "旧符号" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: formSchema.value.symbol_once,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formSchema.value.symbol_once) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])), [
        [_directive_loading, _unref(state).loading]
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})